module.exports = __webpack_public_path__ + "images/bannerEN-2a681102508da81d745b17c02971f6e2.png";